import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import CustomizeYourPipelineImage from './CustomizeYourPipelineImage'

const copy = {
  overline: `Functions`,
  heading: `Customize your pipeline`,
  description: `Functions lets you build any custom integration with Segment, with just ten lines of JavaScript.`,
}

const link = {
  text: `Explore Functions`,
  url: `/product/connections/functions/`,
}

const CustomizeYourPipeline = () => {
  const pageConfig = usePageConfig()

  return (
    <StyledSectionBase variant="2Col" copyVariant="narrow" reverse={true}>
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Overline>{copy.overline}</CopyText.Overline>
          <CopyText.Heading>{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <CustomizeYourPipelineImage />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 40px;
    padding-bottom: 64px;
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

export default CustomizeYourPipeline
